import { gsap } from 'gsap';
export class VerticalSlider {
    el;
    targets;
    constructor(el) {
        this.el = el;
        this.targets = document.querySelectorAll('[data-observer]');
        const options = {
            rootMargin: '0px',
            threshold: 0.75
        };
        const observer = new IntersectionObserver(this.doThings, options);
        this.targets.forEach(target => {
            observer.observe(target);
        });
    }
    doThings(entries, observer) {
        const element = document.querySelector('.vertical-slider');
        const rect = element?.getBoundingClientRect().top ?? 0;
        console.log(rect, 'rect');
        console.log(rect + window.scrollY, 'rect + window.scrollY');
        const addClass = (el) => {
            if (!el.classList.contains('is-visible')) {
                el.classList.add('is-visible');
                el.scrollTo({
                    top: rect + window.scrollY,
                    behavior: 'smooth'
                });
                const title = el.querySelector('h2');
                const caption = el.querySelector('.caption');
                const elements = title?.querySelectorAll('span');
                const tl = gsap.timeline();
                tl.add('start');
                if (elements) {
                    tl.fromTo(elements, {
                        autoAlpha: 0,
                        transform: 'translate3d(0, 100%, 0)'
                    }, {
                        duration: 1,
                        transform: 'none',
                        autoAlpha: 1,
                        stagger: {
                            each: 0.06,
                            from: 'start'
                        },
                        delay: 0.5
                    }, 'start');
                }
                if (caption) {
                    tl.fromTo(caption, {
                        autoAlpha: 0,
                        y: 16,
                        transformOrigin: '50% 50%',
                    }, {
                        autoAlpha: 1,
                        y: 0, transformOrigin: '50% 50%', duration: 0.25,
                        delay: 0.75
                    }, 'start');
                }
            }
        };
        const removeClass = (el) => {
            if (el.classList.contains('is-visible')) {
                el.classList.remove('is-visible');
                const title = el.querySelector('h2');
                const caption = el.querySelector('.caption');
                const elements = title?.querySelectorAll('span');
                const tl = gsap.timeline();
                tl.add('start');
                if (elements) {
                    tl.set(elements, {
                        autoAlpha: 0,
                        transform: 'translate3d(0, 100%, 0)'
                    });
                }
                if (caption) {
                    tl.set(caption, {
                        autoAlpha: 0,
                        y: 16,
                        transformOrigin: '50% 50%',
                    });
                }
            }
        };
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                console.log('add', entry);
                addClass(entry.target);
            }
            else {
                console.log('remove', entry);
                removeClass(entry.target);
            }
        });
    }
}
